import { buildNow } from './buildNow';
import type { DateTimeFormatterFactoriesMap } from './types';


const dateTimeFormatterFactories: DateTimeFormatterFactoriesMap = {
    // 25.05.2025
    date: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
    }),

    // 25.05.25
    dateShort: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        day: 'numeric',
        month: 'numeric',
        year: '2-digit',
    }),

    // 25.05
    dateInYear: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        day: 'numeric',
        month: 'numeric',
    }),

    // 25 мая 2025
    dateLong: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }),

    // 25 мая
    dayMonth: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        day: 'numeric',
        month: 'long',
    }),

    // 25 мая 2025, понедельник
    dateWeekDay: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        weekday: 'long',
    }),

    // 25 мая 2025, пн
    dateWeekDayShort: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        weekday: 'short',
    }),

    // май 2025
    monthYear: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        month: 'long',
        year: 'numeric',
    }),

    // май
    month: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        month: 'long',
    }),

    // понедельник
    weekDay: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        weekday: 'long',
    }),

    // пн
    weekDayShort: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        weekday: 'short',
    }),

    // 25.05.2025 16:30
    dateTime: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }),

    // 25.05 12:00
    dateTimeShort: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        day: 'numeric',
        month: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }),

    // 12:00
    time: (locale, { timeZone }) => new Intl.DateTimeFormat(locale, {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }),

    leftUntil: (_locale, settings, _root, scopedUtils) => {
        const { pluralizeDurationByMaxUnit } = scopedUtils;

        return {
            format: (date: Date): string => {
                const now = buildNow(settings);
                const diffMs = date.getTime() - now.getTime();
    
                return pluralizeDurationByMaxUnit(diffMs);
            }
        };
    },
};


export {
    dateTimeFormatterFactories,
}
